import React from "react";
import { Card, Badge } from "react-bootstrap";

interface ActiveCurrency {
  currency: string;
  amount: number;
  value: number;
}

interface BonusStatusCardProps {
  activeCurrencies: ActiveCurrency[];
  bonusStatus: string;
  startDate: string;
  endDate: string;
}

const BonusStatusCard: React.FC<BonusStatusCardProps> = ({
  activeCurrencies,
  bonusStatus,
  startDate,
  endDate,
}) => {
  const totalPoints = activeCurrencies.reduce((sum, curr) => sum + curr.amount, 0);
  
  return (
    <Card className="border-0 rounded-3 bg-white p-4 h-100">
      <div className="d-flex align-items-center mb-3">
        <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
          <i className="ri-vip-crown-fill text-primary fs-24"></i>
        </div>
        <div>
          {activeCurrencies.length > 0 ? (
            <div>
              <h2 className="mb-1">{totalPoints} Puntos</h2>
              <div className="mb-2">
                {activeCurrencies.map((curr) => (
                  <small key={curr.currency} className="d-block text-muted">
                    {curr.currency}: {curr.amount} puntos
                  </small>
                ))}
              </div>
            </div>
          ) : (
            <h2 className="mb-1">0 Puntos</h2>
          )}
          <Badge bg={bonusStatus === "active" ? "success" : "danger"}>
            {bonusStatus === "active" ? "Activo" : "Inactivo"}
          </Badge>
        </div>
      </div>
      <p className="mb-2">
        <strong>Fecha de inicio:</strong> {startDate}
      </p>
      <p className="mb-0">
        <strong>Fecha de fin:</strong> {endDate}
      </p>
    </Card>
  );
};

export default BonusStatusCard;
